module.exports = __webpack_public_path__ + "img/RX_OLIVOS.8e7d284b.png";